import { WebStorageStateStore, UserManager } from 'oidc-client-ts';
import type { AuthProviderProps } from 'react-oidc-context';

const kcUrl = import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8080';
const kcRealm = import.meta.env.VITE_KEYCLOAK_REALM || 'master';
const kcClientId = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'admin-client';

export const KEYCLOAK_URL = kcUrl;
export const KEYCLOAK_REALM = kcRealm;
export const KEYCLOAK_CLIENT_ID = kcClientId;

const baseUrl = typeof window !== 'undefined' ? window.location.origin : '';

const userStore =
  typeof window !== 'undefined'
    ? new WebStorageStateStore({ store: window.sessionStorage })
    : undefined;

export const userManager = new UserManager({
  authority: `${kcUrl}/realms/${kcRealm}`,
  client_id: kcClientId,
  redirect_uri: `${baseUrl}/redirect_uri`,
  post_logout_redirect_uri: baseUrl,
  silent_redirect_uri: `${baseUrl}/silent-renew.html`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  loadUserInfo: false,
  monitorSession: false,
  userStore,
  metadata: {
    issuer: `${kcUrl}/realms/${kcRealm}`,
    authorization_endpoint: `${kcUrl}/realms/${kcRealm}/protocol/openid-connect/auth`,
    token_endpoint: `${kcUrl}/realms/${kcRealm}/protocol/openid-connect/token`,
    userinfo_endpoint: `${kcUrl}/realms/${kcRealm}/protocol/openid-connect/userinfo`,
    end_session_endpoint: `${kcUrl}/realms/${kcRealm}/protocol/openid-connect/logout`,
    jwks_uri: `${kcUrl}/realms/${kcRealm}/protocol/openid-connect/certs`,
  },
});

export const oidcProviderProps: AuthProviderProps = {
  userManager,
  // Strip ?code/&state from the address bar so a refresh doesn't re-trigger
  // the callback handler. This replaceState is invisible to React Router —
  // the actual post-login navigation happens in the /redirect_uri route
  // (<AuthCallback /> in App.tsx), which issues a real router <Navigate>.
  onSigninCallback: () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('code');
    url.searchParams.delete('state');
    url.searchParams.delete('session_state');
    url.searchParams.delete('iss');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  },
};
